<!--
    @全周期
-->
<template>
    <div>
		<div class="main-content fullCycle fullCss" :style="mainContentViewHeight" v-loading.lock="fullscreenLoading">
			<headerCom class="header" ref="headerCom" :type="3" :pageTitle="'项目全生命周期监管'" @navchange="navClickHandle" @showBox="showBoxHandle" @searchclick="searchClickHandle" :datacount="navTotal"></headerCom>
			<screenCom class="screen" v-if="showFlag" :type="3" :projectTypeList="projectTypeList" @projectemit="projectEmitHandle" :navClick="systemType"></screenCom>
			<div class="my_table">
				<div class="no_message" v-if="dataMsg.length==0">
					<!-- <img src="../../../assets/images/empty.png" alt=""> -->
					<p>暂无数据</p>
				</div>
				<div class="project_item" v-else>
					<projectCom :data="item" :isShowTag="true" :hasViewBtnPer="hasBtnPermission('supperviseion_businessWitnessHis_detail_btn')" :key="i" :keyCopy="i" :systemType="systemType" class="project_par" v-for="(item,i) in dataMsg"></projectCom>
				</div>
				<paginationCom class="limit" :options="paginationOpt" @sizechange="sizeChangeHandle" @pagechange="pageChangeHandle"></paginationCom>
			</div>
		</div>
	</div>
</template>
<script>
import headerCom from '../components/header.vue';
import screenCom from '../components/screen.vue';
import projectCom from '../components/project-com.vue';
import {mapState} from 'vuex';
import {listProjectFlowPaged,dictDataList} from '@/server/busWitnessList.js';
export default {
	props:["mainContentViewHeight"],
	components: {
          headerCom,
		  screenCom,
		  projectCom
    },
	data(){
		return{
			fullscreenLoading:false,
			systemType:'GC',
			navTotal:{CG: 0, GC: 0, GT: 0, CQ:0},
			dataMsg:[
				// {
				// 	"bidSectionCode":"E4111000760220149001001",
				// 	"bidSectionId":"44d44fcc30fa47dbb78b5161b8687742",
				// 	"bidSectionName":"系统测试20220409",
				// 	"flownodeList":[
				// 			{
				// 				"datasetCode":"A03",
				// 				"enableHandle":1,
				// 				"flowId":"1649489944287004",
				// 				"flowWitnessId":"f9a1c63862324202a8bb29b172761e1e",
				// 				"nodeName":"招标项目登记",
				// 				"nodeProgressType":1,
				// 				"nodeTime":"2022-04-09 15:45:31",
				// 				"sort":3,
				// 				"witnessStatus":1
				// 			},
				// 			{
				// 				"datasetCode":"A10",
				// 				"enableHandle":1,
				// 				"flowId":"1649491808214003",
				// 				"flowWitnessId":"dab1b59e5aa94ccfadaaf76effc3c840",
				// 				"nodeName":"招标文件",
				// 				"nodeProgressType":2,
				// 				"nodeTime":"2022-04-09 16:13:28",
				// 				"sort":4,
				// 				"witnessStatus":1
				// 			},
				// 			{
				// 				"datasetCode":"A07",
				// 				"enableHandle":1,
				// 				"flowId":"1649492209440004",
				// 				"flowWitnessId":"5d83058ae9134fdea1810eb0b52f9988",
				// 				"nodeName":"招标公告",
				// 				"nodeProgressType":1,
				// 				"nodeTime":"2022-04-09 16:18:21",
				// 				"sort":5,
				// 				"witnessStatus":1
				// 			},
				// 			{
				// 				"datasetCode":"A23",
				// 				"enableHandle":0,
				// 				"nodeName":"开标记录",
				// 				"nodeProgressType":0,
				// 				"sort":64,
				// 				"witnessStatus":0
				// 			},
				// 			{
				// 				"datasetCode":"A34",
				// 				"enableHandle":0,
				// 				"nodeName":"评标记录",
				// 				"nodeProgressType":0,
				// 				"sort":89,
				// 				"witnessStatus":0
				// 			},
				// 			{
				// 				"datasetCode":"A29",
				// 				"enableHandle":1,
				// 				"nodeName":"中标候选人公示",
				// 				"nodeProgressType":0,
				// 				"sort":101,
				// 				"witnessStatus":0
				// 			},
				// 			{
				// 				"datasetCode":"A31",
				// 				"enableHandle":1,
				// 				"nodeName":"中标结果公告",
				// 				"nodeProgressType":0,
				// 				"sort":102,
				// 				"witnessStatus":0
				// 			},
				// 			{
				// 				"datasetCode":"A53",
				// 				"enableHandle":0,
				// 				"nodeName":"中标通知书",
				// 				"nodeProgressType":0,
				// 				"sort":103,
				// 				"witnessStatus":0
				// 			},
				// 			{
				// 				"datasetCode":"A32",
				// 				"enableHandle":1,
				// 				"nodeName":"合同",
				// 				"nodeProgressType":0,
				// 				"sort":104,
				// 				"witnessStatus":0
				// 			},
				// 			{
				// 				"datasetCode":"A40",
				// 				"enableHandle":1,
				// 				"nodeName":"招标异常",
				// 				"nodeProgressType":2,
				// 				"sort":120,
				// 				"witnessStatus":0
				// 			}
				// 		],
				// 	"openTime":"2022-04-13 08:30:00",
				// 	"passDate":2,
				// 	"passOpenDate":2,
				// 	"projectCode":"E4111000760220149",
				// 	"qualificationMode":"2",
				// 	"qualificationModeName":"资格后审",
				// 	"tenderAgencyName":"系统测试代理1",
				// 	"tenderMode":"1",
				// 	"tenderModeName":"公开招标",
				// 	"tenderProjectCode":"E4111000760220149001",
				// 	"tendererName":"系统测试代理1",
				// 	"warnItemCount":1
				// },
			],
			projectTypeList:[],
			paginationOpt:{
				pageIndex:1,
				pageSize:5,
				total:0,
				pageSizes:[5,10,15]
			},
			searchKey:'',
			tradeId:'',
			showFlag:false,
			projectStatusType:'',
			bidOpenTimeStart:'',
			bidOpenTimeEnd:'',
			buyprojectresultnoticeTimeStart:'',
			buyprojectresultnoticeTimeEnd:'',
			projectStatusList:[],
            superviseDeptCodeList:[]
		}
	},
    watch:{
        uerdefultOptionCode:{
        handler (val,oldVal){
          if(val.length!==0){this.init()}
        }
    }
  },
	computed:{
		...mapState({
            uerdefultOptionCode: state => state.dataDictionary.uerdefultOptionCode,
        })
	},
	activated(){	
		setTimeout(()=>{
			if(this.$route.query.type){
				if(this.$route.query.type==1){
					this.projectStatusList=[3]
				}else{
					this.projectStatusList=[2,1]
				}
			}
			// this.apiworkBenchIndexcountProjectTracking();
			this.apiSysdatadictionaryGetDictionaryName();
			this.init();
		},500)
		
		
	},
	methods:{
		// 获取菜单总条数
		apiworkBenchIndexcountProjectTracking(){
			// apiworkBenchIndexcountProjectTracking().then((res)=>{
			// 	const {data}=res;
			// 	if(data.code=='1'){
			// 		this.navTotal=data.data;
			// 	}
			// })
		},
		// 筛选后获取菜单总条数-工程建设
		apiworkBenchIndexprojectStatusCount(){
			// let listType=this.user.role=='ROLE_JYZX_USER'?2:this.user.role=='ROLE_JYZXSH_USER'?1:1;
			// apiworkBenchIndexprojectStatusCount({
			// 	page:this.paginationOpt.pageIndex,
      		//           rows:this.paginationOpt.pageSize,
			// 	filter:{
			// 		listType:listType,//角色类型
			// 		// systemType:this.systemType,
			// 		projectStatusType:this.projectStatusType,//项目状态
			// 		buyprojectType:this.buyprojectType,//项目类型
			// 		bidOpenTimeStart:this.bidOpenTimeStart,
			// 		bidOpenTimeEnd:this.bidOpenTimeEnd,
			// 		buyprojectresultnoticeTimeStart:this.buyprojectresultnoticeTimeStart,
			// 		buyprojectresultnoticeTimeEnd:this.buyprojectresultnoticeTimeEnd
			// 	},
			// 	searchKey:this.searchKey,
			// 	type:this.systemType
			// }).then((res)=>{
			// 	const {data} = res;
			// 	if(data.code=='1'){
			// 		Object.keys(data.data).forEach(key=>{
			// 			this.navTotal[key]=data.data[key];
			// 		})
			// 	}
			// })
		},
		apiSysdatadictionaryGetDictionaryName(){
			let list={
				'CG':1,
				'GC':2,
				'GT':3,
				'CQ':4,
				'QT':5
			}
			this.projectTypeList=[]
			this.projectTypeList.push({name:'全部',value:''})  
			dictDataList(list[this.systemType]||1).then((res)=>{
				const {data} = res;
				if(data.code=='1'){
					this.projectTypeList.push.apply(this.projectTypeList,data.data);
				}
			})
		},
		// 获取数据
		init(){
         this.superviseDeptCodeList= this.superviseDeptCodeList.length==0?this.uerdefultOptionCode:this.superviseDeptCodeList
			listProjectFlowPaged({
				page:this.paginationOpt.pageIndex,
                rows:this.paginationOpt.pageSize,
				filter:{
					projectStatus:Number(this.projectStatusType) ,
					projectType:this.buyprojectType,
					busType:this.systemType,
					bidOpenStartTime:this.bidOpenTimeStart,
					bidOpenEndTime:this.bidOpenTimeEnd,
					resultNoticeStartTime:this.buyprojectresultnoticeTimeStart,
					resultNoticeEndTime:this.buyprojectresultnoticeTimeEnd,
					projectStatusList:this.projectStatusList,
                    superviseDeptCodeList:this.superviseDeptCodeList||[]
				},
				searchKey:this.searchKey,
			}).then((res)=>{
				const {data} = res;
				if(data.code==1){
					this.dataMsg=data.data.rows||[];
					this.paginationOpt.total=data.data.total||0;
					this.navTotal={CG:0, GC: data.data.total, GT: 0, CQ: 0}
				}
				
			}).finally(()=>{})
		},
		// 每页长度改变
		sizeChangeHandle(value){
			this.paginationOpt.pageSize=value;
			this.paginationOpt.pageIndex=1;
			this.init();
		},
		// 当前页改变
		pageChangeHandle(value){
			this.paginationOpt.pageIndex = value;
			this.init();
		},
		// 菜单点击事件
		navClickHandle(data){
			this.systemType=data;
			this.projectTypeList=[];
			this.projectStatusType='';
			this.paginationOpt={
				pageIndex:1,
				pageSize:5,
				total:0,
				pageSizes:[5,10,15]
			};
			this.apiSysdatadictionaryGetDictionaryName();
			this.init();
		},
		showBoxHandle(val){//是否显示高级搜索
			this.showFlag=val;
			if(this.showFlag==false){
				this.buyprojectresultnoticeTimeEnd='';
				this.buyprojectresultnoticeTimeStart='';
				this.bidOpenTimeEnd="";
				this.bidOpenTimeStart="";
				this.buyprojectType=""
				this.projectStatus=0
				this.init()
			}
		},
		// 搜索点击事件
		searchClickHandle(data,tradeId){
			this.tradeId=tradeId
			this.searchKey = data;
			this.paginationOpt={
				pageIndex:1,
				pageSize:5,
				total:0,
				pageSizes:[5,10,15]
			};
			this.init();
			// this.apiworkBenchIndexprojectStatusCount();
		},
		projectEmitHandle(data){
			console.log(data)
			this.projectStatusType=data.projectStatus;
			this.buyprojectType=data.projectType;
			this.bidOpenTimeStart=data.bidOpenTimeStart;
			this.bidOpenTimeEnd=data.bidOpenTimeEnd;
			this.buyprojectresultnoticeTimeStart=data.buyprojectresultnoticeTimeStart;
			this.buyprojectresultnoticeTimeEnd=data.buyprojectresultnoticeTimeEnd;
            this.superviseDeptCodeList=data.superviseDeptCodeList||[]
			this.paginationOpt={
				pageIndex:1,
				pageSize:5,
				total:0,
				pageSizes:[5,10,15]
			};
			this.init();
			// this.apiworkBenchIndexprojectStatusCount();
		}
	}
}
</script>
<style lang="scss" scoped>
.fullCycle{
	.header{
		background: #ffffff;
		padding:24px;
	}
	.screen{
		margin: 16px;
		background: #ffffff;
		padding: 12px 24px;
		margin-bottom: 0;
	}
	.my_table{
		// padding: 20px;
		background: #ffffff;
		margin: 16px 24px;
		margin-bottom: 0;
		overflow: hidden;
		.no_message{
			margin-top: 70px;
			height: 350px;
			text-align: center;
			p{
				color: rgba(0, 0, 0, 0.65);
				font-weight: 400;
				margin-top: 15px;
				padding-right: 15px;
			}
		}
		.project_item{
			overflow: hidden;
			// padding-bottom: 300px;
			.project_par{
				margin: 16px 24px 0;
			}
		}
		.limit{
			// margin-top: 230px;
			text-align: right;
		}
	}
}
</style>
